import { apiClient } from 'v4/core/apiClient';
import { createEnterpriseFeatureFlagApi } from './enterprise-feature-flag.api.http';

export const myEnterpriseFeatureFlagApi =
  createEnterpriseFeatureFlagApi(apiClient);
